import React, { ReactNode } from 'react';
import { FieldValues, useFormContext, UseFormReturn } from 'react-hook-form';

export interface IFormConsumerProps<TFieldValues extends FieldValues> {
  render: (__form: UseFormReturn<TFieldValues>) => ReactNode;
}

const FormConsumer = <TFieldValues extends FieldValues>({
  render,
}: IFormConsumerProps<TFieldValues>): JSX.Element => (
  <>{render(useFormContext())}</>
);

export default FormConsumer;
